"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractVpcService2 = _interopRequireDefault(require("../AbstractVpcService"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../../util/ServiceUrlUtility"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

var _VpcSkeletonJson = _interopRequireDefault(require("./VpcSkeleton.json.js"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SERVICE_PATH = '/retail/iows/{apiLocalePath}/vpc/configuration';
/**
 * This class is used for saving planner configurations to the IKEA VPC service.
 */

var IowsVpcService = /*#__PURE__*/function (_AbstractVpcService) {
  _inherits(IowsVpcService, _AbstractVpcService);

  var _super = _createSuper(IowsVpcService);

  /**
   * Class constructor.
   */
  function IowsVpcService() {
    var _this;

    _classCallCheck(this, IowsVpcService);

    _this = _super.call(this);
    _this.serviceVersion = '1.0';
    return _this;
  }
  /**
   * Saves a planner configuration.
   *
   * @override
   * @param {VpcServiceConfig} vpcConfig Service config for VPC.
   * @param {Object} productConfig Product configuration object.
   * @param {Object[]} shoppingList Shopping list.
   * @return {Promise} Promise object.
   */


  _createClass(IowsVpcService, [{
    key: "saveConfiguration",
    value: function saveConfiguration(vpcConfig, productConfig, shoppingList) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        delete productConfig.configurationSource;
        fetch(_this2._getUrl(vpcConfig.apiLocalePath), {
          method: 'POST',
          body: _this2._getRequestBody(productConfig, shoppingList),
          credentials: 'same-origin',
          headers: {
            Accept: 'application/vnd.ikea.iows+json; version=' + _this2.serviceVersion,
            Consumer: _ServiceSettings.default.consumer,
            Contract: _ServiceSettings.default.contract.toString(),
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(_this2._handleJsonResponse.bind(_this2)).then(function (response) {
          if (response.VisualConfigurationRef && response.VisualConfigurationRef.ConfigurationId && response.VisualConfigurationRef.ConfigurationId.$) {
            resolve(response.VisualConfigurationRef.ConfigurationId.$);
          } else {
            resolve(response);
          }
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @override
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @param {String} productConfigId Product configuration id.
     * @return {Promise} Promise object.
     */

  }, {
    key: "getConfiguration",
    value: function getConfiguration(vpcConfig, productConfigId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this3._getUrl(vpcConfig.apiLocalePath) + '/' + productConfigId.toUpperCase(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/vnd.ikea.iows+json; version=' + _this3.serviceVersion,
            Consumer: _ServiceSettings.default.consumer,
            Contract: _ServiceSettings.default.contract.toString()
          }
        }).then(_this3._handleJsonResponse.bind(_this3)).then(function (data) {
          var parsedData = _this3._parseResponse(data, vpcConfig.acceptableConfigurationSources);

          if (parsedData !== null) {
            resolve(parsedData);
          } else {
            reject(new _ServiceException.default('Failed to parse VPC data from response. The format was not correct.', _this3.constructor.factoryName));
          }
        }).catch(_this3._rejectWrapper.bind(_this3, reject));
      });
    }
    /**
     * Returns a URL to be used by requests.
     *
     * @param {String} apiLocalePath API locale path. Example: "gb/en".
     * @return {String} Generated URL.
     */

  }, {
    key: "_getUrl",
    value: function _getUrl(apiLocalePath) {
      return _ServiceUrlUtility.default.getBaseUrl() + SERVICE_PATH.replace('{apiLocalePath}', apiLocalePath);
    }
    /**
     * Parses response data.
     *
     * @param {Object} data Data to parse.
     * @param {String[]} [acceptableConfigurationSources] Acceptable configuration sources. Default is "ServiceSettings.applicationName".
     * @return {Object|Null} Parsed data.
     */

  }, {
    key: "_parseResponse",
    value: function _parseResponse(data) {
      var acceptableConfigurationSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var acceptableSources = this._parseConfigurationSources(acceptableConfigurationSources);

      var productConfig = null;

      if (data) {
        var configurationSource = data.VisualConfiguration.ConfigurationSource.$.toUpperCase();

        if (!acceptableSources.includes(configurationSource)) {
          throw new _ServiceException.default('Failed to parse VPC data from response. The configuration source "' + configurationSource + '" did not match the list of acceptable application names (' + acceptableSources.join(', ') + ').', this.constructor.factoryName);
        }

        if (data.contentType === 'application/xml') {
          var _iterator = _createForOfIteratorHelper(data.children[0].children),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var child = _step.value;

              if (child.nodeName === 'ConfigurationData') {
                productConfig = child.children[0].textContent;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          productConfig = JSON.parse(this._fromBase64(productConfig));
        } else {
          var rawdata = data.VisualConfiguration.ConfigurationData.Content.$;
          productConfig = JSON.parse(this._fromBase64(rawdata));
        }

        productConfig.configurationSource = configurationSource;
      }

      return productConfig;
    }
    /**
     * Returns payload to be used when saving a configuration.
     *
     * @param {Object} productConfig Product configuration data.
     * @param {Object[]} shoppingList Shopping list items.
     * @return {Object|Null} Parsed data.
     */

  }, {
    key: "_getRequestBody",
    value: function _getRequestBody(productConfig, shoppingList) {
      var base64Configuration = this._toBase64(JSON.stringify(productConfig));

      var payload = null;
      payload = JSON.parse(JSON.stringify(_VpcSkeletonJson.default));
      payload.VisualConfiguration.ConfigurationSource.$ = _ServiceSettings.default.applicationName.toUpperCase();
      payload.VisualConfiguration.ConfigurationData.Content.$ = base64Configuration;
      var shoppingBagItemList = [];

      var _iterator2 = _createForOfIteratorHelper(shoppingList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          shoppingBagItemList.push({
            ItemNo: {
              $: item.id
            },
            ItemQty: {
              $: item.qty
            },
            ItemType: {
              $: item.type
            },
            SortRelevanceList: {}
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      payload.VisualConfiguration.ConfigurationData.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem = shoppingBagItemList;
      payload = 'inputData=' + JSON.stringify(payload);
      return payload;
    }
    /**
     * Converts data from Base 64 to a string.
     *
     * @param {Object} b64 Base 64 data to convert.
     * @return {String} Converted data.
     */

  }, {
    key: "_fromBase64",
    value: function _fromBase64(b64) {
      return Buffer.from(b64, 'base64').toString();
    }
    /**
     * Converts a string to Base 64.
     *
     * @param {String} str String to convert.
     * @return {Object} Base 64 data.
     */

  }, {
    key: "_toBase64",
    value: function _toBase64(str) {
      return Buffer.from(str).toString('base64');
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'iowsvpc';
    }
  }]);

  return IowsVpcService;
}(_AbstractVpcService2.default);

exports.default = IowsVpcService;